'use client';

import Link from 'next/link';
import paths from '@/paths';
import { HeaderNavLinks } from '../HeaderNavLinks';
import { MobileNav } from '../MobileNav/MobileNav';
import { ProfileDropdown } from '../ProfileDropdown/ProfileDropdown';

export const HeaderWithTabs = () => (
  <header className="sticky w-full top-0 left-0 px-4 mb-2 bg-header backdrop-blur-md border-b border-gray-800 z-[1100]">
    <div className="main-container relative mx-auto h-100 min-h-20 flex flex-wrap items-center justify-between">
      <div className="w-fit lg:w-fit flex justify-start z-[2]">
        <Link href={paths.home()}>
          <img src="/static/images/logo.png" alt="FaunaExplore logo" height={42} width={37} />
        </Link>
      </div>

      <div className="w-fit lg:w-fit min-h-20 flex items-center justify-end gap-3 sm:gap-4 z-[2]">
        <HeaderNavLinks />
        <ProfileDropdown />
        <MobileNav />
      </div>
    </div>
  </header>
);
